<template>
    <div id="app">
        <router-view />

    </div>
</template>

<script>

    export default {
        name: 'app',
        components: {
        },
        data: function () {
            return {
                metaTags: {
                    title: "Sollicita",
                    meta: [
                        { name: 'description', content: 'O Sollicita � a plataforma mais completa para voc� que atua com Licita��es e Contratos Administrativos para a Administra��o P�blica.' },
                        { name: 'keywords', content: 'Not�cias, Licita��es, Contratos, Administra��o, Portal, Plataforma, Conte�do, Sollicita, V�deos, P�blica, Administra��o' },

                        { itemprop: 'name', content: 'Sollicita - A ferramenta completa para licita��es e contratos' },
                        { itemprop: 'description', content: 'O Sollicita � a plataforma mais completa para voc� que atua com Licita��es e Contratos Administrativos para a Administra��o P�blica.' },
                        { itemprop: 'image', content: '114px_rounded.png' },

                        { name: 'twitter:card', content: 'summary' },
                        { name: 'twitter:site', content: '@gruponp' },
                        { name: 'twitter:title', content: 'Sollicita - A ferramenta completa para licita��es e contratos' },
                        { name: 'twitter:description', content: 'O Sollicita � a plataforma mais completa para voc� que atua com Licita��es e Contratos Administrativos para a Administra��o P�blica.' },
                        { name: 'twitter:creator', content: '@gruponp' },
                        { name: 'twitter:image', content: '114px_rounded.png' },

                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:title', content: 'Sollicita - A ferramenta completa para licita��es e contratos' },
                        { property: 'og:url', content: window.location.href },
                        { property: 'og:image', content: '114px_rounded.png"' },
                        { property: 'og:image:secure_url', content: '114px_rounded.png"' },
                        { property: 'og:image:type', content: 'image/png' },
                        { property: 'og:description', content: 'O Sollicita � a plataforma mais completa para voc� que atua com Licita��es e Contratos Administrativos para a Administra��o P�blica.' },
                        { property: 'og:site_name', content: 'Sollicita' },
                        { property: 'og:image:width', content: '300' },
                        { property: 'og:image:height', content: '200' },
                        { property: 'fb:admins', content: 'sollicita' },
                        { property: 'og:type', content: 'website' },

                        { name: 'application-name', content: 'Sollicita' },
                        { name: 'theme-color', content: '#2d5289' },
                        { name: 'msapplication-TileColor', content: '#2d5289' },
                        { name: 'msapplication-TileImage', content: '114px_rounded.png' },
                    ]
                },
            }
        },
        metaInfo() {
            return this.metaTags
        },
    };
</script>

<style lang="scss">
    
</style>

